module.exports = {
  key: 'remove',
  icon: 'md-trash',
  name: '删除任务',
  do(task) {
    this.tasks.splice(this.tasks.indexOf(task), 1);
  },
  undo: 'add',

};
